module.exports = __webpack_public_path__ + "img/pexels-cleyder-duque-3821385.4e5880fe.jpg";